import type { PortableTextBlock } from 'next-sanity';
import { cn } from '@workspace/lib';
import { CustomPortableText } from '@workspace/ui/PortableText';

interface ContentCarouselDescriptionProps {
  hasDescription: boolean;
  description?: PortableTextBlock[];
}

export function ContentCarouselDescription({ hasDescription, description }: ContentCarouselDescriptionProps) {
  if (!hasDescription || !description) return null;

  return (
    <div className={cn('rich-text-container')}>
      <CustomPortableText value={description} maxLines={2} />
    </div>
  );
}
